import { organisationQueryOptions } from "@/server/organisations";
import { dehydrate, HydrationBoundary } from "@tanstack/react-query";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import _ from "lodash";

export const Route = createFileRoute("/_dashboard/organisations/$orgId")({
  component: RouteComponent,
  beforeLoad: ({ location, params }) => {
    const routeParts = _.compact(location.pathname.split("/"));
    const isExactOrgRoute =
      routeParts[routeParts.length - 2] === "organisations" &&
      (routeParts[routeParts.length - 1] === params.orgId || routeParts[routeParts.length - 1] === `${params.orgId}/`);
    if (isExactOrgRoute) {
      throw redirect({
        to: "/organisations/$orgId/users",
        params: { orgId: params.orgId },
      });
    }
  },
  loader: async ({ params, context }) => {
    const queryOptions = organisationQueryOptions(Number(params.orgId));

    //We need to prefetch the query in order to get the name for the breadcrumb
    await context.queryClient.prefetchQuery(queryOptions);
    const organisation = context.queryClient.getQueryData(queryOptions.queryKey) as { name?: string } | undefined;

    return {
      crumb: organisation?.name || "Unknown Organisation",
      dehydratedState: dehydrate(context.queryClient) as any,
    };
  },
});

function RouteComponent() {
  const { dehydratedState } = Route.useLoaderData();
  return (
    <HydrationBoundary state={dehydratedState}>
      <Outlet />
    </HydrationBoundary>
  );
}
